module.exports = __webpack_public_path__ + "mn.svg?30e30d5acd1696b63084ea89a7d1ede3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mn.svg
// module id = 880
// module chunks = 27